/* unplugin-vue-components disabled */import script from "./Auth.vue?vue&type=script&setup=true&lang=js"
export * from "./Auth.vue?vue&type=script&setup=true&lang=js"

import "./Auth.vue?vue&type=style&index=0&id=8829f2f2&lang=less&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/yunibao-invite-h5-prod/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8829f2f2"]])

export default __exports__